import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import {
  increaseCount,
  decreaseCount,
  removeFromCart,
} from "../../slices/CounterSlice.js";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import Cup from "../../images/cup.svg";
import Arrowright from "../../images/keyboard_arrow_right.svg";
import Arrowdown from "../../images/keyboard_arrow_down.svg";
import Close from "../../images/closeBlc.svg";
import ButtonLoader from "../../components/loaders/ButtonLoader.js";
import { fetchRoomNoAndPhoneNo, handleOffers, setRoomNoAndPhoneNo, validatePhoneNumber } from "../../utils/util.js";
import { useNavigate } from "react-router-dom";
import { InroomSubmitButtonClick } from "../../utils/Analytics.js";

export default function PlaceOrder(props) {
  const dispatch = useDispatch();
  const foodCart = useSelector((store) => store.counter.cart);
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const hotelId = localStorage.getItem("hotel-id");
  const appUserId = localStorage.getItem("appUserId");
  const totalFoodList = props.totalFoodList;
  const [filteredFoodCart, SetFilteredFoodCart] = useState(foodCart);
  const [totalPrice, SetTotalPrice] = useState("");
  const [isLoading, SetIsloading] = useState(false);
  const [instructions, setInstruction] = useState("");
  const storedData = fetchRoomNoAndPhoneNo();
  const [gsttotal,SetGstTotal] = useState("");
  const [gstrate,SetGstRate] = useState("");
  const [gstamount,SetGstAmount] = useState("")
  const [roomNo, setRoomNo] = useState(storedData?.room);
  const [mobileNo, setMobileNo] = useState(storedData?.phone ? storedData?.phone : localStorage.getItem("phone_no"));
  const [isOpen, setIsOpen] = useState(false);
  const [confirmRoomNo, setConfirmRoomNo] = useState(storedData?.room);
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const [mobileValidation, setMobileValidation] =  useState(false);
  const [error, setError] =  useState("");
  const navigate = useNavigate();
  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
    setError("")
  };

  const handleConfirmRoomNo = (e) => {
    setConfirmRoomNo(e.target.value);
    setError("")
  };

  const handleInstruction = (e) => {
    setInstruction(e.target.value);
  };

  const toggleDetails = () => setIsOpen(!isOpen);

  useEffect(() => {
    var filterArray = foodCart.filter(
      (cartItem) =>
        cartItem.foodData.restaurantId.toString() === props.restaurantId
    );
    SetFilteredFoodCart(filterArray);
    const totalPrice = filterArray.reduce((sum, item) => {
      return sum + parseFloat(handleOffers(item?.foodData?.price, item?.foodData?.discount) ) * item.count;
    }, 0);
    SetTotalPrice(totalPrice);
    const gstTotal = filterArray.reduce((sum, item) => {
      return sum + (parseFloat(item?.foodData?.gstrate) * item.count);
    }, 0);
    SetGstTotal(gstTotal);
    const gstrate = filterArray[0]?.foodData?.gst?.gst;
    SetGstRate(gstrate); 
    const gstAmount = gstrate ? (totalPrice * gstrate) / 100 : 0;
    SetGstAmount(gstAmount); 
  }, [foodCart]);

  function closeModal() {
    props.closePlaceOrder();
  }

  useEffect(() => {
    var filterArray = foodCart.filter(
      (cartItem) =>
        cartItem.foodData.restaurantId.toString() === props.restaurantId
    );
    if (filterArray.length === 0) {
      props.closePlaceOrder();
    }
    // if (foodCart.length !== 0) {
    //   SetCurrecy(foodCart[0].foodData.currency == "RS" ? "₹" : "$");
    // }
  }, [foodCart]);

  const handleMobile = (number)=>{
      if (/^[0-9+-]*$/.test(number)) {
        setMobileNo(number);
      }
   }

  const handleSubmit = () => {
    const foodArray = cartObjectFormat(filteredFoodCart);
 
    if(isCheckedIn == "true"){
      if(roomNo == ''){
        setError("Please enter room number")
      }else if(confirmRoomNo == ""){
        setError("Please enter confirm room number")
      }else if(roomNo !== confirmRoomNo){
        setError("Room number not match")
      }else{
        InroomSubmitButtonClick();
        orderFood(foodArray);
      }
    }else {
      if(!mobileNo || error){
        console.log("object")
         setError("please enter mobile number")
      } else{
        InroomSubmitButtonClick();
        orderFood(foodArray);
      }
    }
   };

  const orderFood = async (foodArray) => {
    let data = JSON.stringify({
      roomNumber: roomNo,
      restaurantId: props.restaurantId,
      guestId: guestId,
      hotelId: hotelId,
      appUserId: appUserId,
      reservationId: reservationId,
      gst:gstrate,
      items: foodArray,
      instructions,
      contactName : mobileNo,
      promotionId: props?.promotionId
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/inRoomDiningV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      SetIsloading(true);
      const response = await axios.request(config);
      console.log(response.data);
      if (response.data.success) {
        props.showMsg("success");
        SetIsloading(false);
        dispatch(removeFromCart({ filteredFoodCart: filteredFoodCart }));
        setRoomNoAndPhoneNo(roomNo,mobileNo)
        setTimeout(() => {
          navigate("../order-history")
        }, 2000);
      }else{
        props.showMsg();
        props.SetMsg(response.data?.message);
        console.log(response.data?.message)
        SetIsloading(false);
      }
    } catch (e) {
      console.log(e);
      props.SetMsg("error");
      props.showMsg();
      props.showMsg("error");
      SetIsloading(false);
    }
  };
  const cartObjectFormat = (foodCartData) => {
    return foodCartData.map((item) => {
      return {
        item: item.id,
        quantity: item.count,
      };
    });
  };

  return (
    <>
      <Transition appear show as={Fragment}>
        <Dialog as="div" className="relative z-[9999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center sm:p-4 p-2 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full sm:max-w-[55%] max-w-[95%] transform overflow-hidden rounded-2xl bg-[#FAFAFA] p-6 text-left align-middle shadow-xl transition-all relative">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-black"
                  ></Dialog.Title>
                  <button
                    onClick={closeModal}
                    className="absolute top-2 right-3 w-6 h-6 flex justify-center items-center "
                  >
                    <img className="w-4 h-4 " src={Close} alt="" />
                  </button>
                  <div className="mt-2 text-black">
                    <div className=" p-3 orderBox">
                      {filteredFoodCart.map((item, i) => (
                        <div key={i} className="flex flex-col gap-4 mb-4">
                          <div className="flex items-center justify-between w-[100%] ">
                            <div className="flex gap-4 items-center max-sm:w-[65%] w-[85%] ">
                              <div className="flex flex-col gap-1  w-[100%] ">
                                <div className="fudName truncate  text-left  ">
                                  {item.foodData.item_name}
                                </div>
                                <div className="flex items-center gap-3 mt-1">
                                  <div className="price sm:static relative sm:right-12 sm:top-4">
                                    
                                   <div className="flex flex-col gap-0.5  " style={{fontSize:"13px"}}>
                                   {item.foodData?.discount && <span className="line-through text-[10px]" style={{color:"gray"}}>{props.currencySymbol}{item?.price * item.count}</span>}
                                    <span className="m-0" style={{fontWeight:"600"}}>{props.currencySymbol}{parseFloat(handleOffers(item?.price, item.foodData?.discount)  * item.count).toFixed(2)}</span>
                                   </div>
                                  
                                  </div>
                                </div>
                                {/* <div className="text-[11px] text-[#676767]">Edit</div> */}
                              </div>
                            </div>
                            <div className="plcBtn flex item-center">
                              <button
                                onClick={() => {
                                  dispatch(
                                    decreaseCount({
                                      id: item.foodData.id,
                                      foodList: totalFoodList,
                                    })
                                  );
                                }}
                              >
                                -
                              </button>
                              <div>{item.count}</div>
                              <button
                                onClick={() => {
                                  dispatch(
                                    increaseCount({
                                      id: item.foodData.id,
                                      foodList: totalFoodList,
                                    })
                                  );
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="my-3 w-full h-[1px] bg-gray-300"></div>
                      <div className="flex flex-col space-y-1 justify-end">
                        <div className="totalAmt">Total Amount</div>
                        <div className="rs">
                          {props.currencySymbol}
                          {parseFloat(totalPrice).toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 flex items-center justify-between p-3 orderBox">
                      <div className="flex space-x-2 items-center">
                        <img src={Cup} alt="cup" />
                        <input
                          className="text-[#444] text-[6px] font-semibold cooking-info"
                          placeholder="Add Cooking Instructions"
                          onChange={handleInstruction}
                          value={instructions}
                        />
                      </div>
                      {/* <img src={Arrow} alt="arrow" /> */}
                    </div>
                   {isCheckedIn !== "false" ? <div>    
                        <label className="plcLabel pt-8">Room Number </label>
                        <input
                          className="mt-2 orderBox p-2 plcLabel hover:bg-gray-200"
                          type="text"
                          value={roomNo}
                          onChange={handleRoomNo}
                          required
                        />
                        <label className="plcLabel">Confirm Room number</label>
                        <input
                          className="mt-2 orderBox p-2 plcLabel hover:bg-gray-200"
                          type="text"
                          value={confirmRoomNo}
                          onChange={handleConfirmRoomNo}
                          required
                        />
                        <span className="text-red-500 text-sm">{error}</span>
                    </div>:
                    <div className="mt-3">
                      <label htmlFor="Phone no" >mobile no</label>
                      <input
                          className="mt-2 orderBox p-2 plcLabel hover:bg-gray-200"
                          type="text"
                          value={mobileNo}
                          onChange={(e)=>handleMobile(e.target.value)}
                          required
                        />
                          <span className="text-red-500 text-sm">{error}</span>
                         
                    </div>
                    }
                    <div className=" p-3 mt-4 orderBox">
                    <div className="rs flex justify-between items-center"  onClick={toggleDetails}>Bill Amount
                    {isOpen ? 
                      <img src={Arrowdown} alt="arrow" /> : <img src={Arrowright} alt="arrow" /> 
                    }
                    </div>
                    {isOpen && (
                      <>
                        { gstrate !== null ? (
                        <>
                        <div className="totalAmt pt-5"> Item Total : <span>{props.currencySymbol}{parseFloat(totalPrice).toFixed(2)}</span></div>
                        <div className="totalAmt pt-2">GST : <span>{props.currencySymbol}{parseFloat(gstamount).toFixed(2)}</span></div>
                        </>
                        ) : " "}                     
                        <div className="totalAmt pt-2">Grand Total : <span>{props.currencySymbol}{ Number.isNaN(gsttotal) ? parseFloat(totalPrice).toFixed(2) : parseFloat(gsttotal).toFixed(2) }{gstrate == null ? ` (Inclusive of GST)` : ''}</span></div>
                      </>
                    )}
                  </div>
                    <div className="flex mt-10">
                      <button
                        disabled={isLoading}
                        onClick={() => handleSubmit()}
                        className="orderBtn py-4 relative"
                      >
                        <span> Proceed and Checkout</span>
                        {isLoading && <ButtonLoader />}
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
